export function base64ToBlob(base64String: string, contentType): Blob {
  // Remove the prefix and decode the base64 string
  const byteCharacters = atob(base64String.split(",")[1]);
  // Explicitly type the array as BlobPart[], which can include Uint8Array objects
  const byteArrays: BlobPart[] = [];
  // Process the decoded string in chunks
  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers: number[] = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: contentType });
}